module.exports = __webpack_public_path__ + "static/img/bcg4.cd60c640.png";